import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSubSignIndicator = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	focusable: "false",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 1V13H13",
		stroke: "#6D6D6D",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	})
});
export default SvgSubSignIndicator;
